import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function notSymbolValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const symbolPass = control.value?.toString();

    const symbol = /[.,\/#!@$%+^&*;:{}=\-_`~(){}|<>№'"?\[\]\\]/;

    if (symbol.test(symbolPass)) {
      return { "symbolNotValid": true };
    }

    return null;
  };
}
